import { PdfGen } from '../pdf/pdf';
import { OptsBase } from './optsBase';

export const ILayoutBaseSymbol = Symbol('LayoutBase');

export interface ILayoutBaseGen {
  generate(pdf: PdfGen, opts: OptsBase): Promise<void>;
}
